import { Component } from 'react';
// Composants
import { List, Message } from 'semantic-ui-react';
// Librairies
import i18n from '../../locales/i18n';
import { connect } from 'react-redux';
import FormattersUtil from '../../utils/FormattersUtil';

class SubscriptionUsersLimitReachedMessage extends Component {
    render() {
        let { activeOrganization, organization, nbUsers, nbInvitations } = this.props;
        const organizationToCheck = organization || activeOrganization;
        const organizationLabel = organizationToCheck?.label;
        const nbMaxUsers = organizationToCheck?.subscription?.nbUsers || 0;
        const nbLinkedUsers = (nbUsers ?? organizationToCheck?.linkedUsers?.length) || 0;
        nbInvitations = (nbInvitations ?? organizationToCheck?.invitations?.filter(i => i.status !== 'declined')?.length) || 0;
        const nbTotalUsers = nbLinkedUsers + nbInvitations;

        if (!FormattersUtil.checkIfNbElementsReached(nbTotalUsers, nbMaxUsers)) return null;
        return (
            <Message warning style={{ textAlign: 'left' }}>
                <Message.Content>
                    <p style={{ fontSize: '14px', margin: 0 }}>{i18n.t("Attention, le nombre d'utilisateurs maximum de votre licence est atteint :")}</p>
                    <List as='ul' style={{ marginTop: '5px' }}>
                        <List.Item as='li'>{i18n.t("Votre licence prévoit un maximum de {{count}} utilisateur.", { count: nbMaxUsers })}</List.Item>
                        <List.Item as='li'>{i18n.t('Votre organisation "{{organizationLabel}}" compte actuellement {{nbTotalUsers}} utilisateurs dont {{nbLinkedUsers}} actifs et {{nbInvitations}} invitations.', { organizationLabel, nbTotalUsers, nbLinkedUsers, nbInvitations })}</List.Item>
                    </List>
                    <p style={{ fontSize: '14px', margin: 0 }}>{i18n.t("Pour ajouter un nouvel utilisateur, vous pouvez :")}</p>
                    <List as='ul' style={{ marginTop: '5px' }}>
                        {nbInvitations > 0 && <List.Item as='li'>{i18n.t("Supprimer les invitations en cours (non encore validées) qui consomment votre capacité.")}</List.Item>}
                        <List.Item as='li'>{i18n.t("Vous adresser à Grality pour adapter votre abonnement par mail : info@grality.com")}</List.Item>
                    </List>
                </Message.Content>
            </Message>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeOrganization: state.activeOrganization
    };
}

export default connect(mapStateToProps)(SubscriptionUsersLimitReachedMessage);